export class Payroll {
  tenantId: string;
  payGroup: string;
  runNumber: string;
  closedDate: Date;
  status: number;
  paySequence: number;
  payStatusCounts: PayrollStatusCounts;
  groupCode: string;
}

export class PayrollStatusCounts {
  totalPaysCount: number;
  totalPaysAmount: number;
  assignedPaysCount: number;
  createdPaysCount: number;
  ignoredPaysCount: number;
  ignoredPaysAmount: number;
  verifiedPaysCount: number;
  checkTotalItemsCount: number;
  ddTotalItemsCount: number;
  itemsWithExceptionsCount: number;
  notPayableCheckCount: number;
  notPayableDDCount: number;
  notPayableButNotCriticalCheckCount: number;
  notPayableButNotCriticalDDCount: number;
  notCollectableCheckCount: number;
  notCollectableDdCount: number;
  collectablePaysCount: number;
  collectablePaysAmount: number;
  collectableCheckPaysCount: number;
  collectableCheckPaysAmount: number;
  collectableDDPaysCount: number;
  collectableDDPaysAmount: number;
  ignoredNonCollectableCount: number;
  ignoredNonCollectableAmount: number;
  ignoredReversalsCount: number;
  ignoredReversalsAmount: number;
  ignoredInstantChecksCount: number;
  ignoredInstantChecksAmount: number;
  ignoredVoidsCount: number;
  ignoredVoidsAmount: number;
  ignoredOtherCount: number;
  ignoredOtherAmount: number;
}
